import { Contributor } from "@biblioteksentralen/cordata";
import { Box, HStack, StackProps, Text, colors } from "@biblioteksentralen/react";
import { sortAlphabetical } from "@biblioteksentralen/utils";
import { capitalize, unique } from "radash";
import InternalLink from "../../components/InternalLink";
import { useTranslation } from "../../utils/hooks/useTranslation";
import { getAgentPath } from "../cordata/contributors";
import { getTransformedRoleLabel } from "../cordata/roles";
import LabelAndValue from "./LabelAndValue";

type Props = {
  contributors: Contributor[];
} & StackProps;

export const ListContributors = ({ contributors, ...stackProps }: Props) => {
  const { t, ts, lang } = useTranslation();

  const hasContributorsWithDifferingRoles =
    unique(contributors.map(({ roles }) => sortAlphabetical(roles, ({ code }) => code).join("-"))).length > 1;

  if (hasContributorsWithDifferingRoles) console.error("Attempting to list contributors with differing roles");

  const roleCode = contributors[0]?.roles[0]?.marc21Code;
  const roleLabel = getTransformedRoleLabel(lang, roleCode, t);

  return (
    <LabelAndValue label={capitalize(roleLabel ?? "")} {...stackProps}>
      <HStack flexWrap="wrap" columnGap="0.25rem" gap="0" lineHeight="1.2">
        {contributors.length > 0 ? (
          contributors.map((contributor, index) => {
            const path = getAgentPath(contributor.agent);
            if (path)
              return (
                <InternalLink href={path} key={contributor.agent.id} color={colors.black}>
                  {ts(contributor.agent.name)}
                  {index < contributors.length - 1 && ", "}
                </InternalLink>
              );
            return (
              <Box key={contributor.agent.id} color={colors.black}>
                {ts(contributor.agent.name)}
                {index < contributors.length - 1 && ", "}
              </Box>
            );
          })
        ) : (
          <Text>{t("Ukjent")}</Text>
        )}
      </HStack>
    </LabelAndValue>
  );
};
